import { Component } from '@angular/core';
import { LoginComponent } from './login.component';
import { RegisterComponent } from "./register.component";
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-auth',
    imports: [LoginComponent,RouterModule],
    templateUrl: '../ui/auth.component.html',
    styleUrl: '../ui/auth.component.css'
})
export class AuthComponent {

}
